import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

import { LinkRouter, SearchResult } from '@common/models/search-result';

@Component({
    selector: 'aa-search-result-item',
    templateUrl: './search-result-item.component.html',
    styleUrls: [
        './search-result-item.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchResultItemComponent
{
    @Input() searchResult: SearchResult<any>;

    constructor (
        private router: Router
    )
    {
    }

    rowClicked (event: any, sr: SearchResult<any>)
    {
        event.stopPropagation();

        const urlFragments = this.buildUrlFragments(sr.link);

        this.router.navigate(urlFragments);
    }

    private buildUrlFragments (link: LinkRouter): any[]
    {
        const detailsFragment = [...link.params];
        if ( link.extraUrlFragment !== undefined )
        {
            detailsFragment.unshift(link.extraUrlFragment);
        }

        return [link.baseUrlFragment, { outlets: { [link.outlet]: detailsFragment } }];
    }
}
